export const getOwnerIdFromLocalStorage = () => {
  try {
    // Get user data from localStorage
    const userData = localStorage.getItem('admin'); // or whatever key you use
    
    if (userData) {
      const parsedUser = JSON.parse(userData);
      
      // Get the first owner ID from accessList
      if (parsedUser.accessList && parsedUser.accessList.length > 0) {
        return parsedUser.accessList[0]; // Returns "686bb1a61fc5b80c2520d59e"
      }
    }
    
    return null;
  } catch (error) {
    console.error('Error getting owner ID from localStorage:', error);
    return null;
  }
};


export const getOwnerDetailsFromLocalStorage = () => {
  try {
    // Get user data from localStorage
    const userData = localStorage.getItem('admin'); // or whatever key you use
    
    if (userData) {
      const parsedUser = JSON.parse(userData);
      
      // Get the first owner ID from accessList
      // if (parsedUser.accessList && parsedUser.accessList.length > 0) {
      //   return parsedUser.accessList[0]; // Returns "686bb1a61fc5b80c2520d59e"
      // }
      return parsedUser
    }
    
    return null;
  } catch (error) {
    console.error('Error getting owner ID from localStorage:', error);
    return null;
  }
};
